<template>
  <div class="overflow-x justify-content-center mt-5">
      <div class=" p-list-representation-table-main">
        <table class="table table-bordered p-table">
            <thead>
              <tr>
                <th>نام و نام خانوادگی</th>
                <th >شماره موبایل</th>
                <th >کد ملی</th>
                <th >درصد مشارکت</th>
                <th >تاریخ شروع</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in tableData" :key="data.id">
                <th scope="row">{{data.name}}</th>
                <td>{{data.mobile}}</td>
                <td>{{data.national_code}} </td>
                <td>{{data.participation_percent}}</td>
                <td>{{data.dateConvertedJali}}</td>
              </tr>
            </tbody>
          </table>
          <div class="d-flex justify-content-center p-table">
            <pagination v-model="valuePage" :per-page="10" :records="500" @paginate="changePage"/>
          </div>
      </div>

  </div>
</template>

<script>
import addCama from '../../modules/addCama.js'


export default {
    name: 'tableContent',
    props: {
      tableData : { type: [Array, Object], default: [] },
      page      : { type: Number, default: 0 },
    },

    data() {
      return {
        valuePage : 1,
      }
    },

    computed: {

    },

    mounted () {
      this.valuePage = this.page;
    },

    watch: {
      page(data){
        this.valuePage = this.page;
      },

    },

    methods: {
      changePage(data){
        this.$emit("paganationChangePage",data);
      },

      editRepresentation(){
        this.$emit('editRepresentation');
      }


    },

}
</script>
